import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=bf422e4c&scoped=true"
var script = {}
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=bf422e4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf422e4c",
  null
  
)

export default component.exports